import React from 'react';
import PropTypes from 'prop-types';
import NavButtonContainer from './styles/NavigationButtonStyled';
import prev from '../../../images/plan-recurrente/arrow-left.svg';
import next from '../../../images/plan-recurrente/arrow-right.svg';

const NavigationButton = ({ name }) => {
  let img = null;
  if (name.includes('next')) {
    img = next;
  } else {
    img = prev;
  }
  return <NavButtonContainer className={name} background={img} />;
};

NavigationButton.propTypes = {
  name: PropTypes.string.isRequired,
};

export default NavigationButton;
